module.exports = __webpack_public_path__ + "img/hectares-em-monitoramento.e61be643.svg";